import React from 'react'
// import SbEditable from '@storyblok/react';
import Hero from './panels/hero/Hero';
import CTAPanel from './panels/ctaPanel/CTAPanel';
import Placeholder from './internal/placeholder/Placeholder';
import PromotedMediaPanel from './panels/promotedMediaPanel/PromotedMediaPanel';
import MediaListingPanel from './panels/mediaListingPanel/MediaListingPanel';
import LinkCtaButton from './widgets/linkCtaButton/LinkCTAButton';
import SolidCtaButton from './widgets/solidCtaButton/SolidCtaButton';
import TransparentCTAButton from './widgets/transparentCtaButton/TransparentCTAButton';
import VideoModal from './widgets/videoModal/VideoModal';
import ContentModal from './widgets/contentModal/ContentModal';
import TextWidget from './widgets/textWidget/TextWidget';
import TwoColumnTextImageWidget from './widgets/twoColumnTextImageWidget/TwoColumnTextImageWidget';
import VideoWidget from './widgets/videoWidget/VideoWidget';
import StoryListingPanel from "./panels/storyListingPanel/StoryListingPanel"
import TwoColumnGrid from './panels/twoColumnGrid/TwoColumnGrid';
import TwoColumnCard from './widgets/twoColumnCard/TwoColumnCard';
import TwoColumnCardImageBottom from './widgets/twoColumnCardImageBottom/TwoColumnCardImageBottom';
import SingleColumnGeneralPanel from './panels/singleColumnGeneralPanel/SingleColumnGeneralPanel';
import FullWidthColumnCard from './widgets/fullWidthColumnCard/FullWidthColumnCard';
import SingleColumnFloatingPanel from './panels/singleColumnFloatingPanel/SingleColumnFloatingPanel';
import TwoColumnCardMetric from './widgets/twoColumnCardMetric/TwoColumnCardMetric';
import IconTablePanel from './panels/iconTablePanel/IconTablePanel';
import FullWidthImagePanel from './panels/fullWidthImagePanel/FullWidthImagePanel';
import ColumnsPanelOneColumn from './panels/columnsPanel/ColumnsPanelOneColumn';
import ColumnsPanelTwoColumn from './panels/columnsPanel/ColumnsPanelTwoColumn';
import ColumnsPanelThreeColumn from './panels/columnsPanel/ColumnsPanelThreeColumn';
import ColumnsPanelFourColumn from './panels/columnsPanel/ColumnsPanelFourColumn';
import ContactForm from './forms/contactForm/ContactForm';
import OldContactForm from './forms/configurable-contact-form/OldContactForm';
import ConfigurableContactForm from './forms/configurable-contact-form/ConfigurableContactForm';
import FrenchContactForm from './forms/FrenchContactForm/FrenchContactForm';
import MetalPowdersContactForm from './forms/contactFormWithMessage/MetalPowdersContactForm';
import CopperContactForm from './forms/contactFormWithMessage/CopperContactForm';
import IndustryContactForm from './forms/industryContactForm/IndustryContactForm';
import TimeLinePanel from "./panels/timeLinePanel/TimeLinePanel";
import ImageModal from './widgets/imageModal/ImageModal';
import ColumnsPanelThreeColumnImageButtons from './panels/columnsPanel/ColumnsPanelThreeColumnImageButtons';
import ImageWidget from './widgets/imageWidget/ImageWidget';
import QuoteWidget from './widgets/quoteWidget/quoteWidget';
import FullWidthColumnCardPanel from './panels/fullWidthColumnCardPanel/fullWidthColumnCardPanel';
import FullWidthResponsiveGraphic from './panels/fullWidthResponsiveGraphic/fullWidthResponsiveGraphic';
import LinkCTAModal from './widgets/linkCTAModal/LinkCTAModal';
import EventListingPanel from './panels/eventListingPanel/EventListingPanel';
import FeaturedEventsPanel from './panels/FeaturedEventsPanel/FeaturedEventsPanel';
import speakerWidget from './widgets/speakerWidget/SpeakerWidget';
import twoColumnSpeaker from './panels/twoColumnSpeakerPanel/twoColumnSpeaker';
import oneColumnSpeaker from './panels/oneColumnSpeakerPanel/oneColumnSpeaker';
import ThreeColumnBlogPanel from './panels/threeColumnBlogPanel/ThreeColumnBlogPanel';
import metricCallout from './widgets/metricCallout/metricCallout';
import ColumnsPanelTwoColumnImageButtons from './panels/columnsPanel/ColumnsPanelTwoColumnImageButtons';
import AnimationPanel from './panels/animationPanel/AnimationPanel';
import AnimationPanelDetails from './panels/animationPanel/AnimationPanelDetails';
import SocialShare from './widgets/socialShareWidget/socialShare';
import ImageTextPanel from './panels/imageTextPanel/ImageTextPanel';
import MasonryGridPanel from './panels/masonryGridPanel/MasonryGridPanel';
import CodeEmbed from './widgets/codeEmbed/codeEmbed';
import TimeLinePanelVertical from './panels/timeLinePanel/TimeLinePanelVertical';
// import { storyblokEditable } from '@storyblok/react';
//import { storyblokEditable } from 'gatsby-source-storyblok';
import SbEditable from "storyblok-react";
import MultiIndustryInfograpicsPanel from './panels/multiIndustryInfographicsPanel/multiIndustryInfographicsPanel';
import ColumnsPanelOneColumnImageButtons from './panels/columnsPanel/ColumnsPanelOneColumnImageButtons';
import ConfigurableLandingForm from './forms/configurable-contact-form/ConfigurableLandingForm';

const Components = {
  'hero': Hero,
  'cta_panel': CTAPanel,
  'link_cta': LinkCtaButton,
  'linked_cta': LinkCtaButton,
  'solid_cta': SolidCtaButton,
  'transparent_cta': TransparentCTAButton,
  'promoted_media_panel': PromotedMediaPanel,
  'media_listing_panel': MediaListingPanel,
  'video_modal': VideoModal,
  'content_modal': ContentModal,
  'text_widget': TextWidget,
  'two_column_text_image_widget': TwoColumnTextImageWidget,
  "video_widget": VideoWidget,
  "story_listing_panel": StoryListingPanel,
  "two_column_grid": TwoColumnGrid,
  "two_column_card": TwoColumnCard,
  "two_column_card_image_bottom": TwoColumnCardImageBottom,
  "single_column_general_panel": SingleColumnGeneralPanel,
  "full_width_column_card": FullWidthColumnCard,
  "single_column_floating_panel": SingleColumnFloatingPanel,
  "two_column_card_metric": TwoColumnCardMetric,
  "full_width_image": FullWidthImagePanel,
  "columns_panel_one_column": ColumnsPanelOneColumn,
  "columns_panel_two_column": ColumnsPanelTwoColumn,
  "columns_panel_three_column": ColumnsPanelThreeColumn,
  "columns_panel_four_column": ColumnsPanelFourColumn,
  "icon_table_panel": IconTablePanel,
  "contact_form": ContactForm,
  "configurable_contact_form": ConfigurableContactForm,
  "configurable_landing_form": ConfigurableLandingForm,
  "french_contact_form": FrenchContactForm,
  "metal_powders_contact_form": MetalPowdersContactForm,
  "copper_contact_form": CopperContactForm,
  "industry_contact_form": IndustryContactForm,
  "old_contact_form": OldContactForm,
  "timeline": TimeLinePanel,
  "image_modal": ImageModal,
  "columns_panel_three_column_image_buttons": ColumnsPanelThreeColumnImageButtons,
  "columns_panel_two_column_image_buttons": ColumnsPanelTwoColumnImageButtons,
  "columns_panel_one_column_image_buttons": ColumnsPanelOneColumnImageButtons,
  "image_widget": ImageWidget,
  "quote_widget": QuoteWidget,
  "full_width_column_card_panel": FullWidthColumnCardPanel,
  "full_width_responsive_graphic": FullWidthResponsiveGraphic,
  "link_cta_modal": LinkCTAModal,
  "event_listing_panel": EventListingPanel,
  "featured_events_panel": FeaturedEventsPanel,
  "speaker": speakerWidget,
  "two_column_speaker": twoColumnSpeaker,
  "one_column_speaker": oneColumnSpeaker,
  "three_column_blog_panel": ThreeColumnBlogPanel,
  "metric_callout": metricCallout,
  "animation_panel": AnimationPanel,
  "animation_details": AnimationPanelDetails,
  "social_share_widget": SocialShare,
  "image_text_panel": ImageTextPanel,
  "masonry_grid_panel": MasonryGridPanel,
  "code_embed": CodeEmbed,
  "timeline_vertical": TimeLinePanelVertical,
  "columns_panel_image_buttons_multi_industry": MultiIndustryInfograpicsPanel
}

const DynamicComponent = ({ blok, data, locale, story }) => {
  if (typeof Components[blok.component] !== 'undefined') {
    const Component = Components[blok.component];

    if (blok.component === "media_listing_panel") {
      return (<SbEditable content={blok}><Component blok={blok} key={blok._uid} cardData={data.mediaListingData} locale={locale} /></SbEditable>)
    }

    if (blok.component === "story_listing_panel") {
      return (<SbEditable content={blok}><Component blok={blok} key={blok._uid} cardData={data.storyListingData} topicData={data.topicData} locale={locale} /></SbEditable>)
    }

    if (blok.component === "event_listing_panel") {
      return (<SbEditable content={blok}><Component blok={blok} key={blok._uid} cardData={data.eventListingData} locale={locale} /></SbEditable>)
    }

    if (blok.component === "featured_events_panel") {
      return (<SbEditable content={blok}><Component blok={blok} key={blok._uid} cardData={data.featuredEventListingData} locale={locale} /></SbEditable>)
      // return (<Component {...storyblokEditable(blok)} blok={blok} key={blok._uid} cardData={data.featuredEventListingData} locale={locale} />)
    }

    if (blok.compontent === "social_share_widget") {
      return (<SbEditable content={blok}><Component blok={blok} story={story} key={blok._uid} locale={locale} /></SbEditable>)
      // return (<Component {...storyblokEditable(blok)} blok={blok} story={story} key={blok._uid} locale={locale} />)
    }
    //return (<Component {...storyblokEditable(blok)} blok={blok} story={story} key={blok._uid} locale={locale} />)
    return (<SbEditable content={blok}><Component blok={blok} story={story} key={blok._uid} locale={locale} /></SbEditable>)
  }

  return  blok.component ? <Placeholder componentName={blok.component}/> : null
}

export default DynamicComponent
